$( document ).ready(function() {



  // Main company filter
    $('#kompanija-fiter .checkbox-fields input').on('click', function() {

      $(this).toggleClass('active');

      $(this).parent().find('span').toggleClass('active');


      var status =[];
      var category = [];


      $(' #kompanija-fiter .category input[type=checkbox]:checked').each(function() {
        category.push(this.value);
      });


      JSON.stringify(category);


      $(' #kompanija-fiter .status input[type=radio]:checked').each(function() {
        status.push(this.value);
      });

      JSON.stringify(status);


      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
          action: 'filter_projects',
          'category' : category,
          'status' : status,
        },
        beforeSend: function(){
         // Show image container
         $(".loading-kompanijas").addClass("loading");
         $(".project-tiles").empty();
         $(' #kompanija-fiter input').attr('disabled', '');
        },
        success: function(res){
         $('.project-tiles').html(res);
        },
        complete:function(data){
         // Hide image container
         $(".loading-kompanijas").removeClass("loading");
         $(' #kompanija-fiter input').removeAttr('disabled');
        }

      });
    });



































    // Hide Header on on scroll down
    var programScrolling = false;
	var didScroll;
	var lastScrollTop = 0;
	var delta = 1;
	var navbarHeight = $('.site-header').outerHeight() - 25;
	$(window).scroll(function(event){
        if (programScrolling) {
            return;
        }
	    didScroll = true;
	});

	setInterval(function() {
        if (programScrolling) {
            return;
        }
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);

	function hasScrolled() {
	    var st = $(this).scrollTop();
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
	        $('.site-header').removeClass('nav-down').addClass('nav-up');
			$(".site-header").removeClass('isTop');
	    } else {
	        // Scroll Up
	        if(st + $(window).height() < $(document).height()) {
	            $('.site-header').removeClass('nav-up').addClass('nav-down');
	        }
	    }

	    lastScrollTop = st;
	}
	//Check if menu is at top of the page
	function isTop(){
		if($(window).scrollTop() === 0) {
			$(".site-header").addClass('isTop');
		}else{
			//$(".site-header").removeClass('isTop');
		}
	}
	isTop();
	$(document).scroll(function() {
        if (programScrolling) {
            return;
        }
	  isTop();
	});

    //Toggle mobile menu
    $('.navbar-toggler').click(function(){
        if ($('.navbar-toggler').prop('checked')) {
            $('body').addClass('menu-open');
            $('html').addClass('overflow');
        }else{
            //$('body').addClass('menu-closing');
            $('html').removeClass('overflow');
            //setTimeout(function(){
                $('body').removeClass('menu-open');
                //$('body').removeClass('menu-closing');
            //}, 300);
        }
    });

    // WPB post overview
    $( '.wpb_ip_post_overview_wrap:not(.show-all) .wpb_ip_post_overview_items' ).each( function() {
        var $status = $(this).parent().find('.slick-control .pagingInfo .pageinfo-total');
        var $slickElement = $( this );

        var myCounter = $(this).parent().find('.slick-control .pagingInfo .pageinfo-current');
        myCounter.numberAnimate({
          animationTimes: [100, 500, 100]
        });

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            if(!slick.$dots){
              return;
            }
            var current_slide = $slickElement.find('.slick-dots .slick-active button').text();
            if (current_slide.toString().length == 1) {
                current_slide = ('0' + current_slide).slice(-2);
            }
            if (slick.slideCount.toString().length == 1) {
              $status.html( ('0' + slick.$dots[0].children.length).slice(-2) );
            }else{
               $status.html( slick.$dots[0].children.length );
            }
            myCounter.numberAnimate('set', current_slide);
        });
        $( this ).slick( {
            infinite: true,
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            fade: false,
            appendArrows: $(this).parent().find('.slick-control .slick-arrows'),
            responsive: [{
                breakpoint: '480',
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              }]
        } );

    } );

    // WPB gallery slider
    $( '.wpb_pi_gallery_wrap .wpb_pi_gallery_items' ).each( function() {
        var $status = $(this).parent().find('.slick-control .pagingInfo .pageinfo-total');
        var $slickElement = $( this );

        var myCounter = $(this).parent().find('.slick-control .pagingInfo .pageinfo-current');
        myCounter.numberAnimate({
          animationTimes: [100, 500, 100]
        });

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          i = ('0' + i).slice(-2);
          $status.html( ('0' + slick.slideCount).slice(-2) );
          myCounter.numberAnimate('set', i);
        });
        $( this ).slick( {
            infinite: true,
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            appendArrows: $(this).parent().find('.slick-control .slick-arrows'),
        } );

    } );

    // Column content slider
    $( '.vc_tta-panels-container .vc_tta-panels' ).each( function() {
        var $slickElement = $( this );

        $( this ).after('<div class="slick-control"><span class="slick-arrows"></span><span class="pagingInfo"><div class="pageinfo-current">1</div><div class="pageinfo-line"></div><div class="pageinfo-total">1</div></span></div>');

        var $status = $(this).parent().find('.slick-control .pagingInfo .pageinfo-total');

        var myCounter = $(this).parent().find('.slick-control .pagingInfo .pageinfo-current');
        myCounter.numberAnimate({
          animationTimes: [100, 500, 100]
        });

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          i = ('0' + i).slice(-2);
          $status.html( ('0' + slick.slideCount).slice(-2) );
          myCounter.numberAnimate('set', i);
        });
        $( this ).slick( {
            infinite: true,
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: false,
            appendArrows: $(this).parent().find('.slick-control .slick-arrows'),
            responsive: [{
                breakpoint: '480',
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              }]
        } );

    } );

    // Pagination
    $( '.pagination .page-item a' ).each( function() {
        var value = $(this).text();
        $(this).html( ('0' + value).slice(-2) );
    });

    //Submit search form
    $( ".btn-search" ).click(function(e) {
        e.preventDefault()
        if ( $(window).width() <= 991 ) {
            if (!$(this).parents('.show-input').length){
                $(this).closest('.searchform').addClass('show-input');
            }else{
                $( this ).closest('.searchform').submit();
            }
        }else{
            if ($('.site-header').hasClass('nav-up') && !$(this).parents('.show-input').length){
                $(this).closest('.searchform').addClass('show-input');
            }else{
                $( this ).closest('.searchform').submit();
            }
        }
    });

    //News page mobile category select
    $('.filter_cat, .filter_status').on('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });

      //Mailchimp form Checkbox
      $('.mc4wp-checkbox label').click(function(){
          if ($(this).find('input[type="checkbox"]').is(":checked")) {
              $(this).addClass('checked');
          }else{
              $(this).removeClass('checked');
          }
      });
      //select2
      $('.filter_cat').select2({
          minimumResultsForSearch: -1
      });
      $('.filter_status').select2({
          minimumResultsForSearch: -1
      });

      //close menu when clicked outside
    $(document).mouseup(function(e){
        var container = $(".dropdown-menu-wrap, .site-header-inner");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0 && $('body').hasClass('menu-open'))
        {
            $('.navbar-toggler').click();
        }
    });


    // $('div.flex-spaced-column-element').each(function() {
    //   var href = $(this).find("h3 a").attr('href');
    //   $(this).wrap( "<a class='navigation-link' href='" + href + "'></a>" );
    // });


    // $("span.mc4wp-checkbox-contact-form-7 input").prop("checked", true);
    // $("span.mc4wp-checkbox-contact-form-7 > label").addClass("checked");


    // $('span.mc4wp-checkbox-contact-form-7 input[type="checkbox"]').click(function(){
    //     if($(this).is(":checked")){
    //         console.log("Checkbox is checked.");
    //     }
    //     else if($(this).is(":not(:checked)")){
    //         console.log("Checkbox is unchecked.");
    //     }
    // });

    $('.file-upload label').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		$(this).parents('.file-upload').find('.form-control-file').trigger('click');
	});
	$('.form-control-file').on('change', function(event) {
		event.preventDefault();
		/* Act on the event */
		var fileName = event.target.files[0].name;
		$('.file-upload label').text(fileName);
	});


  $('.wpcf7').on('wpcf7:mailsent', function(event){
      var fileName2 = " ";
      $('.file-upload label').text(fileName2);
  });

});
